<form class="form" [formGroup]="form" (submit)="submit()">
  <h2>Complimentary Therapy Sessions</h2>

  <div>
    <p>Would you like to offer Complimentary Therapy Sessions?</p>
    <iris-form-field class="large-field full-width" label="Complimentary Sessions" [showOptionalTag]="false">
      <iris-text-input type="number" [attr.min]="currentCount" formControlName="maxRedemptions"></iris-text-input>
    </iris-form-field>
    <div class="error-list alert alert-danger" *ngIf="errors">
      <ng-container *ngIf="errors.persona_provider?.no_network">
        You are not configured to offer complimentary sessions - please contact support.
      </ng-container>
      <ng-container *ngIf="errors.base?.server_error">
        Error adding complimentary sessions, please try again in a moment.
      </ng-container>
    </div>
  </div>

  <iris-button-container [alignment]="IrisButtonContainerAlignments.END" class="button-container">
    <iris-button [buttonType]="IrisButtonTypes.TERTIARY">Cancel</iris-button>
    <iris-button 
      [buttonType]="IrisButtonTypes.PRIMARY"
      [typeAttribute]="IrisButtonTypeAttributeOptions.SUBMIT"
    >Confirm</iris-button>
  </iris-button-container>
</form>
